/**
 *
 * Add multiple products to the cart in one action.
 *
 * @author: Pietro Vignola <pvignola[at]kooomo[dot]com>
 *
 */

/**
 * @event document#click.zg.shopByLook Click on the plugin selector button
 * @type {null}
 */

/* global _, zgPost, JS_TRANSLATIONS */

(function ($) {
  'use strict'

  /**
     * @selector data-zg-role="sbl-buy-all" The plugin start if there is the selector (button) in the dom when the page load
     */
  const selector = '[data-zg-role="sbl-buy-all"]'

  // SHOPBYLOOK CLASS DEFINITION
  // ===========================

  const ShopByLook = function (element, options) {
    this.$element = $(element)
    this.options = options
  }

  /**
     * @param {string} [target] Container of products list linked
     * @param {string} [product] Container of main product
     */
  ShopByLook.DEFAULTS = {
    target: '[data-zg-role="sbl-items"]',
    product: '[data-zg-role="product"]'
  }

  /**
     * Get product for this container SBL target
     */
  ShopByLook.prototype.getProducts = function () {
    const $target = $(document).find(this.options.target)
    const data = $target.data()

    let $products = $target.find(this.options.product)

    if (data.sblCheckbox) {
      $products = $products.filter(function () {
        let isValid = false

        if ($(this).find('[name="' + data.sblCheckbox + '"]:checked').length) {
          isValid = true
        }

        return isValid
      })

      if (!$products.length) {
        $(document).trigger('zg-error', [{
          message: window.JS_TRANSLATIONS.please_select || 'Please select at least a product.'
        }])
      }
    }

    if ($products.length > 0) {
      this.checkProducts($products)
    }
  }

  /**
     * Check if products are available and have sku selected
     */
  ShopByLook.prototype.checkProducts = function ($products) {
    if (!$products.length) {
      return false
    }

    const multivalues = []
    const validProducts = []
    const notAvailable = []
    const notOptionsSelected = []

    $products.each(_.bind((key, element) => {
      const zgProduct = $(element).data('zg.product')

      if (zgProduct) {
        if (zgProduct.selectedSku && (zgProduct.selectedSku !== 0)) {
          if (zgProduct.isAvailable) {
            multivalues[zgProduct.product.id] = zgProduct
            validProducts.push(multivalues[zgProduct.product.id])
          } else if (zgProduct.availabilityChecked) {
            notAvailable.push(zgProduct.product.name)
          }
        } else if ( !zgProduct.selectedSku && !zgProduct.product.options ) { // products with no sku and options are valid products
          if (zgProduct.isAvailable) {
            multivalues[zgProduct.product.id] = zgProduct
            validProducts.push(multivalues[zgProduct.product.id])
          } else if (zgProduct.availabilityChecked) {
            notAvailable.push(zgProduct.product.name)
          }
        } else {
          if (zgProduct.product.options) {
            notOptionsSelected.push(zgProduct.product.name)
          }
        }
      }
    }, this))

    this.multiAddToCartRequest(validProducts, notOptionsSelected, notAvailable)
    this.showNotification('following.products.not.available', notAvailable)
    this.showNotification('following.products.have.no.options.selected', notOptionsSelected)

    return true
  }

  /**
     * @method multiAddToCartRequest
     */

  ShopByLook.prototype.multiAddToCartRequest = function (validProducts, notOptionsSelected, notAvailable) {
    console.log("valid products", validProducts)
    console.log("no options selected", notOptionsSelected)
    console.log("not available", notAvailable)
    if (!validProducts.length || notOptionsSelected.length || notAvailable.length) {
      return false
    }

    let callback
    const data = {
      items: []
    }

    _.each(validProducts || [], element => {
      let addToCart

      if (element.product && element.options.enableAddToCart) {
        addToCart = element.options.enableAddToCart

        // Add to the cart
        if (addToCart) {
          data.items.push({
            product_id: element.product.id,
            sku: element.selectedSku,
            quantity: element.cleanQuantity() || 1
          })
        }
      }
    })

    if (data.items.length) {
      callback = {
        success: _.bind(data => {
          $(document).trigger('zg.product.addedToCart', [data, validProducts])
        }, data),
        error() {
          // Something went wrong. Request the cart items again.
          $(document).trigger('zg.getProductList.request-info', ['cart'])
        }
      }

      zgPost(
        'addProductToCart',
        data,
        {
          success: window.JS_TRANSLATIONS['add.to.cart.multiple']
        },
        callback
      )
    }
  }

  /**
     * Show notification with subject message
     */
  ShopByLook.prototype.showNotification = function (msg, subject) {
    if (!subject.length) {
      return false
    }

    $(document).trigger('zg-error', [{
      message: window.JS_TRANSLATIONS[msg] + ' ' + subject.toString()
    }])
  }

  // SHOPBYLOOK PLUGIN DEFINITION
  // ============================

  const Plugin = function (option) {
    return this.each(function () {
      const $this = $(this)
      let data = $this.data('zg.shopByLook')
      const options = $.extend({}, ShopByLook.DEFAULTS, window.ZG_CONFIG || {}, $this.data(), typeof option === 'object' && option)

      if (!data) {
        $this.data('zg.shopByLook', (data = new ShopByLook(this, options)))
      }

      data.getProducts()
    })
  }

  $.fn.zgShopByLook = Plugin
  $.fn.zgShopByLook.Constructor = ShopByLook

  /**
     * @method document
     * @listen document#click.zg.shopByLook On click of selector the plugin start
     */

  $(() => {
    $(document).on('click.zg.shopByLook', selector, function () {
      Plugin.call($(this))
    })
  })
})(jQuery)
